export const localDataSort = (sortPropertyName: string, sortDirection: "asc" | "desc") => (a: any, b: any) => {
  const sortDirectionPolarity = sortDirection === "desc" ? 1 : -1;
  if ((b[sortPropertyName] == null && a[sortPropertyName] == null) || b[sortPropertyName] === a[sortPropertyName]) {
    return 0;
  } else if (b[sortPropertyName] == null) {
    return -1 * sortDirectionPolarity;
  } else if (a[sortPropertyName] == null) {
    return 1 * sortDirectionPolarity;
  } else {
    return (b[sortPropertyName] < a[sortPropertyName] ? -1 : 1) * sortDirectionPolarity;
  }
};
